// base
import { createContext } from 'react';

export interface LoadingContextProps {
  isLoading: boolean;
  setLoading: (value: boolean) => void;
}

export const LoadingContext = createContext<LoadingContextProps>({
  isLoading: false,
  setLoading: () => {}
});
